import React, { useMemo } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Modal, Text } from 'v3/components';
import Loader from 'v3/components/Loader';
import { formatDateTime } from 'v3/utils/formatter';
import {
  buildQuestionnaireAnswersPayload,
  buildQuestionnaireSchema,
  getInitialAnswers,
  getVisibleQuestions,
} from 'v3/services/cteQuestionnaire';
import QuestionField from './QuestionField';
import { AnsweredBanner } from './styles';

export default function CteQuestionnaireModal({
  open,
  onClose,
  questions = [],
  loading = false,
  submitting = false,
  completed = false,
  answeredAt = null,
  answeredUser = null,
  onSubmit,
}) {
  const initialValues = useMemo(
    () => getInitialAnswers(questions),
    [questions]
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.lazy(values =>
      buildQuestionnaireSchema(getVisibleQuestions(questions, values))
    ),
    validateOnMount: true,
    onSubmit: async values => {
      const payload = buildQuestionnaireAnswersPayload(questions, values);
      await onSubmit(payload);
    },
  });

  const visibleQuestions = getVisibleQuestions(questions, formik.values);

  return (
    <Modal
      show={open}
      handleClose={onClose}
      size="sm"
      heading={
        <Text color="dark" type="header" weight="500">
          Questionário de confirmação de entrega
        </Text>
      }
      body={
        loading ? (
          <div className="d-flex justify-content-center py-4">
            <Loader size="md" loading />
          </div>
        ) : visibleQuestions.length === 0 ? (
          <div className="py-4 text-center">
            <Text type="regular" color="placeholder">
              Nenhuma pergunta cadastrada para este CT-e.
            </Text>
          </div>
        ) : (
          <>
            {completed && (
              <AnsweredBanner>
                <Text type="regular" color="success" weight="500">
                  Questionário respondido
                  {answeredUser?.name ? ` por ${answeredUser.name}` : ''} em{' '}
                  {formatDateTime(answeredAt)}.
                </Text>
              </AnsweredBanner>
            )}
            {questions.map(question => (
              <QuestionField
                key={question.id}
                question={question}
                values={formik.values}
                errors={formik.submitCount > 0 ? formik.errors : {}}
                onAnswerChange={(questionId, value) =>
                  formik.setFieldValue(String(questionId), value)
                }
                readOnly={completed}
              />
            ))}
            {!completed && (
              <div className="d-flex flex-column align-items-center mt-4">
                <Button
                  onClick={formik.handleSubmit}
                  loading={submitting}
                  disabled={!formik.isValid}
                >
                  <Text type="regular" weight="500">
                    Salvar
                  </Text>
                </Button>
              </div>
            )}
          </>
        )
      }
    />
  );
}
